// extracted by mini-css-extract-plugin
export default {"container":"mainPageInput_container__OIa7c","container__img":"mainPageInput_container__img__q1WRK","container__submit-button":"mainPageInput_container__submit-button__8vjEb"};